import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import Locale from "@/helper/locale/locale.js";
// import { TrackingService } from "@/helper/TrackingHelper.js";
//core
import { CallbackEvent } from "@/core/Utility/CallbackEvent.js";
//service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import BlobService from '@/core/BlobService/service/BlobService.js';
import { UserLevel } from '@/core/UserLevel/UserLevel.js'
import { CartItems } from '@/core/ShoppingCart/model/ItemAddToCartModel.js';

export function DetailController () {
    this.lbl = Locale.getLbl();

    this.isLoading = false;
    this.campaignConfig = null;
    this.campaign = {};
    this.subCampaign = {};
    this.campaignId = null;
    this.type = '';
    this.point = 0;
    this.pointType = '';
    this.price = 0;
    this.originalPrice = 0;
    this.discount = 0;
    this.qty = 0;
    this.quantity = 0;
    this.isFavorite = false;

    this.selectedCampaignId = null;
    this.selectedQuantity = 0;

    this.cartItemLoad = false;
    this.cartItem = 0;

    this.passcode_category = [];

    this.horoscope_category = null;


    //modal
    this.modalController = null;
    //event
    this.cbApiResponseError = new CallbackEvent();
    this.cbGetCampaignSuccess = new CallbackEvent();
    this.cbRedeemSuccess = new CallbackEvent();
    this.cbUpdatePoint = new CallbackEvent();
    //before redeem
    this.cbShoppingCart = new CallbackEvent();
    this.cbOpenWeb = new CallbackEvent();
    this.cbOpenSurvey = new CallbackEvent();
    this.cbCallApi = new CallbackEvent();
    this.cbShipping = new CallbackEvent();
    this.cbRedeem = new CallbackEvent();
    this.cbRedirect = new CallbackEvent();

    // this.trackingService = new TrackingService(this),

    //#region setup
    this.initialCampaign = function (bzbsToken, campaignConfig, controller) {
        this.campaignConfig = campaignConfig;
        this.modalController = controller;
        this.initialPasscodeConfig();
        this.getCampaignDetail(bzbsToken);
    };
    this.initialPasscodeConfig = function () {
        BlobService.getCategoryConfig()
            .then(res => {
                if (res)
                this.passcode_category = res.data;
            }).catch(err => {
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });
    };
    this.updateCampaignInfo = function () {
        this.campaignId = this.campaign.id;
        this.subCampaign = this.campaign.subCampaignStyles;
        this.type = this.campaign.type;
        this.point = this.campaign.pointPerUnit;
        this.pointType = this.campaign.pointType;
        this.price = this.campaign.pricePerUnit;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.qty = this.campaign.qty;
        this.quantity = this.campaign.quantity;
        this.isFavourite = this.campaign.isFavourite;
    };
    this.selectSubCampaign = function (selectedItem) {
        this.campaignId = selectedItem.campaignId;
        this.point = selectedItem.points;
        this.price = this.campaign.price;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.quantity = selectedItem.quantity;
    };
    this.setSelectedQuantity = function (selectedQuantity) {
        this.selectedQuantity = selectedQuantity;
    };
    this.setHoroscopeCategory = function (category) {
        this.horoscope_category = category;
    };
    //#endregion setup

    //#region setter
    //#endregion setter

    //#region campaign
    this.getCampaignDetail = function (isByPassLoading) {
        if(!isByPassLoading) {
            if (this.showLoading()) return;
        }

        var token = Account.getToken();
        BzbsCampaign.apiGetCampaignDetail(token, this.campaignConfig)
            .then(res => {
                this.campaign = res;
                this.updateCampaignInfo();
                if (this.campaign.type == 3)
                    this.getCartItem();

                this.hideLoading();
                this.cbGetCampaignSuccess.sendCallback();
            }).catch(err => {
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });
    };
    //#endregion campaign
    //#region
    this.openSurvey = function(){
        let website = this.campaign.website;
        let token = Account.getTokenShuffle();
        let theme = 'cpf';
        let locale =  Locale.getLocaleCode();
        let header = true;
        let return_url = encodeURIComponent(window.location.href);
        let user_type = this.getUserType();
        website = website
            + '&token=' + token
            + '&theme=' + theme
            + '&locale=' + locale
            + '&header=' + header
            + '&return_url=' + return_url
            + '&user_type=' + user_type
        window.location.replace(website)
    };
    this.getUserType = function(){
        let userLevel = new UserLevel();
        if(userLevel.isDist()){
            return 'dist'
        }else if(userLevel.isSubdist()){
            return 'subdist'
        }else if(userLevel.isSale()){
            return 'sale'
        }else{
            return 'farmer'
        }
    };
    //end#region
    //#region confirm redeem
    this.confirmRedeem = function () {
        if (this.campaign.type == Vue.CampaignType.Interface) {
            switch (this.campaign.interfaceDisplay) {
                case 'web':
                    this.cbOpenWeb.sendCallback(this.campaign);
                    break;
                case 'survey':
                case 'surveyapprove':
                    this.openSurvey();
                    break;
                // case 'surveyapprove':
                //     this.cbOpenSurvey.sendCallback();
                //     break;
                case 'api':
                    this.cbCallApi.sendCallback();
                    break;
            }
        } else if (this.campaign.type == Vue.CampaignType.Buy) {
            this.addToCart();
        } else if (this.campaign.delivered) {
            this.modalController.shippingModal
                .clearModal()
                .setTitle(this.lbl.shipping.detail_headline)
                .setTag('detail-shipping')
                .setPage('detail')
                .show();

            this.modalController.shippingModal
                .onSelected(address => {
                    this.redeem(address);
                });

            this.cbShipping.sendCallback();
        } else if (this.campaign.type == Vue.CampaignType.VerifyCode) { // add 27/08/2024 (Campaign Type VerifyCode)
            this.modalController.verifyCodeModal
                .clearModal()
                .setCampaign(this.campaign)
                .show()
            this.modalController.verifyCodeModal.onClickOk((data) => {
                this.redeemVerifyCode(data);
            })
               
        } else if (this.campaign.type == Vue.CampaignType.Donate) {
            this.redeem(null, this.campaign.pointPerUnit);
            this.cbRedeem.sendCallback();
        } else {
                this.redeem();
                this.cbRedeem.sendCallback();
            }
        };
    //#endregion confirm redeem
    //#region redeem
    this.clickRedeem = function () {
        if (this.selectedQuantity > 1) {
            this.selectedQuantity = this.selectedQuantity * this.campaign.pointPerUnit;
            this.campaign.pointPerUnit = this.selectedQuantity;
        }
        this.modalController.confirmRedeemModal
            .clearModal()
            .setCampaign(this.campaign)
            .show()

        this.modalController.confirmRedeemModal
            .onClickConfirm(() => {
                this.confirmRedeem();
            });
    };
    this.redeem = function (address, spPoints) {
        if (this.showLoading()) return;

        var redeemAddressConfig = {
            addressKey: null,
        };
        var selectedQuantity = {
            spPoints: null,
        };

        if (address) {
            var addressItem = address.getParams();
            redeemAddressConfig.addressKey = addressItem.key;
        }
        if (!isNaN(spPoints) ) {
            selectedQuantity.spPoints = spPoints;
        }
        
        var token = Account.getToken();
        BzbsCampaign.apiRedeemCampaign(token, this.campaignId, null, redeemAddressConfig, null, null, selectedQuantity)
            .then(res => {
                this.campaign.updateAfterRedeem(res);
                this.updateCampaignInfo();

                this.hideLoading();

                //check horoscope campaign
                if(parseInt(this.horoscope_category) == parseInt(this.campaign.categoryID)){
                    this.cbRedirect.sendCallback(this.campaign);
                }else{
                    this.initSerial();
                }

                //wait for db update.
                setTimeout(() => {
                    this.getCampaignDetail(true);
                    this.cbUpdatePoint.sendCallback(res.updated_points);
                }, 1000);
            }).catch(err => {
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });
    };

    // add 27/08/2024 (Campaign Type VerifyCode)
    this.redeemVerifyCode = function (verifycode) {
        if (this.showLoading()) return;

        let params = { verifycode: verifycode }
        var token = Account.getToken();

        BzbsCampaign.apiRedeemCampaign(token, this.campaignId, params, null)
            .then(res => {

                this.modalController.successModal
                        .clearModal()
                        .setTitle('แลกของรางวัลสำเร็จ')
                        .setMsg(`ตรวจสอบการแลกรางวัลได้ที่หน้า </br> ‘ประวัติการแลกคะแนน’`)
                        .setBtnOk('แลกรางวัลเพิ่ม')
                        .setBtnCancel('ดูประวัติการแลกคะแนน')
                        .show();

                this.modalController.successModal.onClickOk(() => {
                    this.cbRedeemSuccess.sendCallback({page: '/'});
                });

                this.modalController.successModal.onClickCancel(() => {
                    this.cbRedeemSuccess.sendCallback({page: '/history/burn'});
                });

                this.campaign.updateAfterRedeem(res);
                this.updateCampaignInfo();
                this.hideLoading();

                //wait for db update.
                setTimeout(() => {
                    this.getCampaignDetail(true);
                    this.cbUpdatePoint.sendCallback(res.updated_points);
                }, 1000);
            }).catch(err => {
                this.modalController.verifyCodeModal.showError(err)
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });
    };
    //#endregion redeem
    //#region cart
    this.setAddToCartParams = function (selectedCampaignId, selectedQuantity)  { 
        this.selectedCampaignId = selectedCampaignId;
        this.selectedQuantity = selectedQuantity;
    }
    this.addToCart = function () {
        if (this.showLoading()) return;

        var token = Account.getToken();

        let cartItem = new CartItems();
        cartItem.addItem(this.selectedCampaignId, this.selectedQuantity);
        let cartParams = cartItem.getParams();

        BzbsCart.apiAddItemToCart(token, cartParams)
            .then(res => {
                this.hideLoading();
                console.log(res);
                this.modalController.addToCartModal.show();
                this.getCartItem();
            }).catch(err => {
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });

        this.hideLoading();
    };
    this.getCartItem = function () {
        var token = Account.getToken();
        BzbsCart.apiCartItem(token)
            .then(res => {
                this.cartItem = res;
                this.cartItemLoad = true;
                console.log("item", this.cartItem);
                this.cbShoppingCart.sendCallback(this.cartItem);
            }).catch(err => {
                this.cbApiResponseError.sendCallback(err);
            });
    }

    this.initialCartItem = async function() {
        return new Promise(resolve => {
            var token = Account.getToken();
            BzbsCart.apiCartItem(token)
                .then(res => {
                    resolve(res);
                }).catch(err => {
                    this.cbApiResponseError.sendCallback(err);
                });
        });
    },
    //#endregion cart
    //#region serial
    this.initSerial = function () {
        if (this.campaign.type == Vue.CampaignType.Donate) {
            this.modalController.alertModal
                .setTitle(this.lbl.modal_donate.title)
                .setMsg(this.lbl.modal_donate.msg)
                .setBtnOk(this.lbl.modal_donate.close)
                .setTag('txt-gray-3')
                .setBtnSecondary()
                .show();
            this.modalController.alertModal.onClickOk(() => {
                window.location.reload();
            });
        } else {
            this.modalController.serialModal
                .setCampaign(this.campaign)
                .setPage('detail')
                .setTag('detail')
                .setPasscodeCategory(this.passcode_category)
                .show();

            this.modalController.serialModal
                .onClickAction(data => {
                    if (data) {
                        switch(data.action) {
                            case 'history':
                                this.cbRedeemSuccess.sendCallback({page: '/history/burn'});
                                break;
                        }
                    }
                });

            this.modalController.serialModal
                .onClickClose(data => {
                    if (data.tag == 'detail-passcode') {
                        this.modalController.confirmModal
                            .clearText()
                            .setTag('redeem-success')
                            .setTitle(this.lbl.serial.redeem_success_headline)
                            .setMsg(this.campaign.name)
                            .setBtnCancel(this.lbl.serial.redeem_success_close)
                            .setBtnOk(this.lbl.serial.redeem_success_history)
                            .show();

                        this.modalController.confirmModal.onClickCancel(() => {
                            this.modalController.confirmModal.hide();
                        });

                        this.modalController.confirmModal.onClickOk(() => {
                            this.cbRedeemSuccess.sendCallback({page: '/history/burn'});
                        });
                    }
                });
        }
    };
    //#endregion serial

    //#region favourite
    //#endregion favourite
    //#region loading
    this.showLoading = function () {
        if (this.isLoading) return true;
        this.isLoading = true;

        this.modalController.loadingModal.show();
    };
    this.hideLoading = function () {
        this.isLoading = false;
        this.modalController.loadingModal.hide();
    };
    //#endregion
}
